import { Component, Fragment } from 'react'
import API from '../../api'
import RatingStars from '../helpers/RatingStars'
import ReviewLabel from '../helpers/ReviewLabel'
import { mealPlanIcon } from '../resort/ResortPricingRow'
import { FormattedMessage } from 'react-intl'
import DateFormat from '../helpers/DateFormat'
import PriceVariants from './PriceVariants'

export default class MapPopup extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedShop: null,
      loading: true,
    }
  }

  componentDidMount() {
    this.getShopInfo()
  }

  componentDidUpdate(prevProps) {
    if(prevProps.shopId !== this.props.shopId ||
      (this.props.shopId && JSON.stringify(prevProps.selectedParams) !== JSON.stringify(this.props.selectedParams))) {
      this.getShopInfo()
    }
  }

  getShopInfo() {
    this.setState({
      loading: true,
    })
    API(`search/resort/${this.props.shopId}/`).get(this.props.selectedParams).then((selectedShop) => {
      this.setState({
        selectedShop,
        loading: false,
      })
    })
  }

  render() {
    const { selectedShop, loading } = this.state
    const { selectedParams, totalGuests, isAllParamsSelected } = this.props
    return (<div className={`shop-info-popup ${loading ? 'loading' : ''}`}>
      { selectedShop
        ? (<Fragment>
          <div className='shop-popup-close' onClick={() => this.setState({ selectedShop: null }, this.props.onPopupClose)}>
            <span className='font-icons close-icon' />
          </div>
          <div className='shop-popup-image' style={{ backgroundImage: `url(${selectedShop.background.GridSearchResultDesktop})` }} />
          <div className='shop-popup-data'>
            <p className='shop-title'>{ selectedShop.title }</p>
            <RatingStars rating={selectedShop.stars} />
            <ReviewLabel
              scubaTribe={selectedShop.scubaTribe}
              shopKind={selectedShop.kind}
              padiRating={selectedShop.numberOfReviews}
              tripAdvisor={selectedShop.tripAdvisor}
              urlParams={{ location: selectedShop.referenceLocationCountrySlug || selectedShop.countrySlug, slug: selectedShop.slug || selectedShop.shopSlug }}
            />
            <div className={`amenities 
            ${selectedShop.numberOfReviews > 2 || selectedShop.tripAdvisor ? 'have-rating' : ''}
            ${selectedShop.minimalStay > selectedParams.nights ? 'minimal-stay' : ''}
          }`}>
              <p><i className='font-icons calendar-icon' />
                <DateFormat date={selectedParams.dateStart} format='MMM DD YYYY' /> -
                <DateFormat date={selectedParams.dateTo} format='MMM DD YYYY' />
              </p>
              <p>
                <i className={mealPlanIcon(selectedShop.mealPlan)} />
                { selectedShop.mealPlanTitle }</p>
              { selectedParams.divers ? (
                <p>
                  <i className='font-icons dive-center-icon' />
                  <FormattedMessage id='incl_number_of_dives'
                    values={{ numberOfDives: selectedShop.numberOfDives }}
                    defaultMessage='Incl. {numberOfDives, plural, one {# dive} other {# dives}}' />
                </p>
              ) : ''}
            </div>
            <PriceVariants
              shop={selectedShop}
              selectedParams={selectedParams}
              totalGuests={totalGuests}
              isAllParamsSelected={isAllParamsSelected} />
            <a className='btn-red' target='_blank' href={selectedShop.url}><FormattedMessage id='view_resort' defaultMessage='View resort' /></a>
          </div>
        </Fragment>) : ''}
    </div>)
  }
}
